<template>
    <plain-layout :isPlain="true" :showTerms="false">
        <common-content-spacer height="small">
            <h1 class="">Authenticating...</h1>
        </common-content-spacer>
    </plain-layout>
</template>
<script>
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PlainLayout from 'components/layouts/PlainLayout'
    import AuthAPI from 'api/AuthAPI'
    export default {
        mixins: [HandleRequestMixin],
        components: {
            PlainLayout,
        },
        methods: {
            afterSent() {
                this.$router.push({
                    name: 'ehr.index',
                    query: {
                        key: this.$route.query.key,
                    },
                })
            },
            login(email, accessToken) {
                this.handleRequest(AuthAPI.ehrLogin(email, accessToken))
                    .then(({ AuthenticationResult }) => {
                        const { AccessToken, IdToken, RefreshToken } = AuthenticationResult
                        this.$auth.logIn(AccessToken, IdToken, RefreshToken)
                        this.afterSent()
                    })
                    .catch(() => {
                        this.errorMessage = this.$t('forms.auth.login.microcopy.not_found_error')
                    })
            },
        },
        mounted() {
            this.login(this.$route.query.email, this.$route.query.token)
        },
    }
</script>
